"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyIconFactory = exports.IconBox = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const rambda_1 = require("rambda");
const StyledSvg = styled_components_1.default.svg `
  fill: currentColor;
  display: inline-block;
  vertical-align: middle;

  ${({ cssWidth }) => cssWidth != null &&
    (0, styled_components_1.css) `
      width: ${cssWidth};
    `};

  ${({ cssHeight }) => cssHeight != null &&
    (0, styled_components_1.css) `
      height: ${cssHeight};
    `};
`;
const defaultUnitTo = (v) => (typeof v === 'string' ? v : `${v}px`);
const isSVGRoot = (children) => Boolean(children && typeof children === 'object' && 'type' in children && children.type === 'svg');
exports.IconBox = (0, react_1.memo)((0, react_1.forwardRef)(({ size, width, height, children, ...props }, ref) => {
    const sizes = width == null && height == null
        ? {
            cssWidth: defaultUnitTo(size != null ? size : 64),
            cssHeight: defaultUnitTo(size != null ? size : 64),
        }
        : {
            cssWidth: width != null ? defaultUnitTo(width) : undefined,
            cssHeight: height != null ? defaultUnitTo(height) : undefined,
        };
    let childrenProps;
    if (isSVGRoot(children)) {
        childrenProps = children.props;
    }
    else {
        childrenProps = {
            children: children,
        };
    }
    return (react_1.default.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", 
        // typings go crazy with ref type here, don't know why
        ref: ref, ...childrenProps, viewBox: "0 0 64 64", ...props, ...sizes }));
}));
const lazyIconFactory = (componentPromiseMap) => {
    const componentLazyMap = (0, rambda_1.map)((k, v) => (0, react_1.lazy)(k), componentPromiseMap);
    return {
        preloadIcons: (...codes) => Promise.all(codes.map((_) => componentPromiseMap[_]())),
        LazyIcon: (0, react_1.memo)((0, react_1.forwardRef)(({ code, ...props }, ref) => {
            const iconCode = Object.keys(componentPromiseMap).find((_) => _.toLowerCase() === `${code}`.toLowerCase());
            if (iconCode == null) {
                console.error(`Icon with code ${code} was not defined!`);
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            const Component = componentLazyMap[iconCode];
            if (Component == null) {
                console.error(`Icon with code ${code} was not provided!`);
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(exports.IconBox, { ...props }) },
                react_1.default.createElement(Component, { ...props, ref: ref })));
        })),
    };
};
exports.lazyIconFactory = lazyIconFactory;
